<template>
    <div class="invitation">
        <div class="content-box first info">
            <h4>邀请好友入驻，好友将获￥20减免，我将获￥20提现</h4>
            <p>对方使用你的邀请码支付成功后，且成功入驻秀动发行，才能获得提现奖励哦！获取收益后，可前往“收益”中进行即时提现</p>
            <div class="sr-descriptions horizontal">
                <div class="item">
                    <label><svg-icon icon-class="amount"></svg-icon>可提现金额</label>
                    <div class="text">
                        <Amount size="samll" :value="(statistic && statistic.hasCashbackAmount) || 0">
                        </Amount>
                    </div>
                    <el-button type="text" class="underline"
                        @click="$router.push('/manage/settlement/overall')">立即提现</el-button>
                </div>
                <div class="item">
                    <label><svg-icon icon-class="yitixian"></svg-icon>已提现金额</label>
                    <div class="text">
                        <Amount size="samll" :value="(statistic && statistic.cashbackAmount) || 0">
                        </Amount>
                    </div>
                </div>
                <div class="item">
                    <label><svg-icon icon-class="key"></svg-icon>我的邀请码</label>
                    <div class="text">
                        <span class="bold">{{ (code && code.id) || '' }}</span>
                    </div>
                    <el-button v-if="!code || !code.id" type="text" class="underline"
                        @click="$router.push('/passport/register')">付费获取</el-button>
                    <el-button v-else type="text" class="underline"
                        @click="onCopy((code && code.id) || '')">复制邀请码</el-button>
                </div>
                <div class="item">
                    <label><svg-icon icon-class="link"></svg-icon>我的邀请链接</label>
                    <div class="text">
                        <span class="bold"> {{ invitationUrl }}</span>
                    </div>
                    <el-button type="text" class="underline" @click="onCopy(invitationUrl)">复制邀请链接</el-button>
                </div>
            </div>
        </div>
        <div class="content-box">
            <div class="title">收益及提现流水</div>
            <div class="page-list-box">
                <el-table v-loading="recordsLoading" ref="recordsList" :data="recordsList" style="width: 100%" stripe>
                    <el-table-column prop="toInvitedName" label="邀请艺人" show-overflow-tooltip></el-table-column>
                    <el-table-column label="奖励金额" show-overflow-tooltip align="center">
                        <template slot-scope="scope">￥{{ scope.row.cashbackAmount }}元</template>
                    </el-table-column>
                    <el-table-column prop="settlementStatus" label="提现状态" align="right" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span v-if="scope.row.settlementStatus == -1">无需提现</span>
                            <span v-else-if="scope.row.settlementStatus == 1">未提现</span>
                            <span v-else-if="scope.row.settlementStatus == 2">已提现</span>
                            <span v-else-if="scope.row.settlementStatus == 3">待结清</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div v-if="recordsData" class="page-pagination-box">
                <el-pagination background @size-change="handleSizeChange" @current-change="getRecords"
                    :current-page.sync="recordsParams.pageNo" :page-sizes="$pageSizes"
                    :page-size.sync="recordsParams.pageSize" layout="prev, pager, next"
                    :total="recordsData.totalCount || 0"></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            dataLoading: false,
            statistic: null,
            tabsName: '2',
            recordsData: null,
            recordsList: [],
            recordsLoading: false,
            recordsParams: {
                pageNo: 1,
                pageSize: this.$pageSizes[0]
            },
            code: null
        };
    },
    computed: {
        userInfo() {
            return this.$store.state.userInfo;
        },
        invitationUrl() {
            const { id } = this.code || {};
            return window.location.origin + '?invitationCode=' + id || '';
        }
    },
    mounted() {
        this.getStatistic();
        this.getRecords();
        this.getCode();
    },
    methods: {
        onCopy(text) {
            const self = this;
            this.$copyText(text).then(
                function () {
                    self.$message.success('复制成功');
                },
                function () {
                    self.$message.error('复制失败');
                }
            );
        },
        //获取统计信息
        getStatistic() {
            this.dataLoading = true;
            this.$request({
                url: '/invitation/record/statistic',
                method: 'get'
            })
                .then(res => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        this.statistic = result;
                    } else {
                        this.$message.error(msg || '获取数据失败,请重试');
                    }
                })
                .catch(() => {
                    this.$message.error('获取数据失败,请重试');
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        //获取邀请记录
        getRecords() {
            this.recordsLoading = true;
            this.$request({
                url: '/invitation/records',
                method: 'GET',
                params: this.recordsParams
            })
                .then(res => {
                    //处理成功回调
                    const { state, msg, result } = res.data;
                    if (state) {
                        this.recordsData = result;
                        this.recordsList = result.result;
                    } else {
                        return this.$message.error(msg || '获取邀请记录失败');
                    }
                })
                .catch(() => {
                    this.$message.error('获取邀请记录失败,请重试');
                })
                .finally(() => {
                    this.recordsLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.recordsParams.pageNo = 1;
            this.recordsParams.pageSize = e;
            this.getRecords();
        },
        //获取邀请码
        getCode() {
            this.$request({
                url: '/invitation/code',
                method: 'GET'
            })
                .then(res => {
                    //处理成功回调
                    const { state, msg, result } = res.data;
                    if (state) {
                        this.code = result || null;
                    } else {
                        return this.$message.error(msg || '获取邀请码失败');
                    }
                })
                .catch(() => {
                    this.$message.error('获取邀请码失败,请重试');
                })
                .finally(() => { });
        }
    }
};
</script>
<style lang="scss" scoped>
.invitation {
    .info {
        text-align: center;

        h4 {
            font-size: 24px;
            color: $-text-950;
            line-height: 24px;
        }

        p {
            margin-top: 14px;
            color: $-text-500;
        }
    }
}
</style>
